import { gql } from '@apollo/client'
import { CONTACT_FRAGMENT } from '../Fragments'

export const CONTACT_QUERY = gql`
  query getContact($id: ID!) {
    contact(id: $id) {
      ...ContactFragment
    }
  }
  ${CONTACT_FRAGMENT}
`
